import { createContext } from 'react';

export const bondSAccIdContext = createContext<number>(-1);
